<template>
</template>

<script>
export default {
  name: 'RegisterLayout'
};
</script>